import type { ReactNode } from 'react';
import { Box } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { DYNAMIC_URLS } from 'consts';

import { useFormsListContext } from '../../context';
import { useFormRowContext } from './FormRowContext';

type Props = {
  children: ReactNode;
};

export const Row = ({ children }: Props) => {
  const { form } = useFormRowContext();
  const { id } = form;
  const { isFormMassActionsSelected } = useFormsListContext();
  const isChecked = isFormMassActionsSelected(id);
  const navigate = useNavigate();

  return (
    <Box
      component="tr"
      sx={theme => ({
        '&&': {
          backgroundColor: isChecked ? theme.colors.blue[1] : undefined,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: theme.colors.blue[1],
            '& a': { textDecoration: 'underline' },
            '& svg': { visibility: 'visible' },
          },
        },
      })}
      onClick={() => {
        navigate(DYNAMIC_URLS.formEdit({ formId: id }));
      }}
    >
      {children}
    </Box>
  );
};
